import { Socket } from "phoenix";

//Socket local
// let socket = new Socket("ws://localhost:4001/socket", { params: {token: localStorage.getItem("x-nz-token-socket") ?? ""} });

//Socket Server
let socket = new Socket("/socket", { params: { token: localStorage.getItem("x-nz-token-socket") ?? ""} });

if (localStorage.getItem("x-nz-token-socket") ?? "") {

  socket.connect();

} else {

  socket.disconnect();

}

export default socket;
